import React, { useRef, useState } from "react";
import ResetPasswordModel from "../ResetPasswordModel";

function EnterCodeModel({ showEnterCodeModal, onCloseEnterCodeModal }) {
  const [showResetPasswordModal, setShowResetPassowordModal] = useState(false);
  const [code, setCode] = useState(["", "", "", ""]);
  const inputsRef = useRef([]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (!isNaN(value) && value.length <= 1) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);

      // Move to the next input
      if (value && index < 3) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  const handleOpenModel = (e) => {
    e.preventDefault();
    setShowResetPassowordModal(true);
  };

  const handleCloseModal = () => {
    setShowResetPassowordModal(false);
  };

  return (
    <div>
      <div
        className={`fixed inset-0 flex items-end justify-center    ${
          showEnterCodeModal ? "block" : "hidden"
        }`}
      >
        <div
          className="fixed inset-0 bg-black opacity-50 "
          onClick={onCloseEnterCodeModal}
        ></div>
        <div className="bg-white dark:bg-[#000]  w-full md:w-1/2  p-5  pb-10 shadow-lg transform transition-transform duration-300  rounded-t-[56px] px-4">
          <div className="flex justify-center ">
            <div className="border-2 border-[#5D5FEF] w-32 mt-3 mb-8"></div>
          </div>

          <div className="flex flex-col items-center  px-12  bg-white dark:bg-[#000] mb-10">
            <div className="space-y-3 ">
              <p className="font-extrabold text-[27px] mt-10 px-10 mx-6">
                Enter 4 Didits Code
              </p>
              <p className="  px-10 text-[20px] font-bold mx-6">
                Enter the 4 digits code that you received on your email.
              </p>
              <div>
                <div className="flex flex-col items-center px-12 mt-20">
                  <div className="space-y-3">
                    <div className="flex space-x-3">
                      {code.map((digit, index) => (
                        <div
                          key={index}
                          className="w-20 border border-[#D9D9D9] justify-center  rounded-[15px] bg-[#D9D9D9] h-20 mb-10 items-center"
                        >
                          <input
                            type="text"
                            value={digit}
                            onChange={(e) => handleChange(e, index)}
                            ref={(el) => (inputsRef.current[index] = el)}
                            className="w-full focus:outline-none  bg-[#D9D9D9] dark:text-[#000] h-full  rounded-[15px] px-2 p-2 text-center"
                            maxLength={1}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center   px-12 ">
            <div className="">
              <button
                onClick={handleOpenModel}
                className="w-80 boder border-[#D9D9D] rounded-[25px] bg-[#2A71E8] p-5 text-white  font-bold mb-10 text-[20px] "
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>

      <ResetPasswordModel
       onCloseResetPasswordModel={handleCloseModal}
        showResetPasswordModal={showResetPasswordModal}
      />
    </div>
  );
}

export default EnterCodeModel;
